/* @flow */

import { USER_DETAILS, USER_SIGN_IN, USER_SIGN_OUT } from '../constants/apiTypes';
import { API_CALL_SUCCESS } from '../constants/actionTypes';
import { fetchNotifications } from '../actions/notificationCentreActions';
import { NOTIFICATIONS_POLL_DURATION } from '../constants/pollDurations';

type Callback = any => any;
type StoreObj = {
  dispatch: Dispatch<*>,
  getState: () => GlobalState
};

function notificationsMiddleware() {
  let pollTracker;

  return ({ dispatch, getState }: StoreObj) => (next: Callback) => (action: any) => {
    const { settings } = getState();

    if (settings.displayFriends && action.type === API_CALL_SUCCESS) {
      switch (action.api) {
        case USER_DETAILS:
        case USER_SIGN_IN:
          if (!pollTracker) {
            dispatch(fetchNotifications());
            pollTracker = window.setInterval(() => {
              dispatch(fetchNotifications());
            }, NOTIFICATIONS_POLL_DURATION);
          }
          break;
        case USER_SIGN_OUT:
          if (pollTracker) {
            window.clearInterval(pollTracker);
            pollTracker = undefined;
          }
          break;
        default:
      }
    }

    return next(action);
  };
}

export default notificationsMiddleware;
